
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';

import Dropdown from '../Dropdown';
import Avatar from './Avatar';

import styles from '../styles.js';

class AvatarSection extends Component {
    static propTypes = {
        dropdown: PropTypes.object.isRequired,
        dropdownLinkGroups: PropTypes.array.isRequired,
        toggleNavDropdown: PropTypes.func.isRequired,
        user: PropTypes.object.isRequired
    }

    handleToggle = () => {
        if (!this.props.dropdown.isVisible) {
            this.props.toggleNavDropdown();
        }
    }

    render() {
        const {
            dropdown,
            dropdownLinkGroups,
            toggleNavDropdown,
            user
        } = this.props;
        return (
            <div>
                <a
                    className={css(styles.navLink)}
                    onClick={this.handleToggle}
                >
                    <div className={css(styles.underlineWrapper)}>
                        <div className={css(styles.underline)}>
                            <div className={css(styles.avatar)}>
                                <Avatar
                                    firstName={user.firstName}
                                    lastName={user.lastName}
                                    userImageSrc={user.avatar}
                                />
                            </div>
                        </div>
                    </div>
                </a>
                {
                    dropdown.isVisible ?
                        <Dropdown
                            dropdown={dropdown}
                            dropdownLinkGroups={dropdownLinkGroups}
                            toggleNavDropdown={toggleNavDropdown}
                        /> : null
                }
            </div>
        );
    }
}

export default AvatarSection;



// WEBPACK FOOTER //
// ./src/components/Header/Nav/AvatarSection/AvatarSection.jsx